import { QueryClientProvider } from '@tanstack/react-query';
import AntdApp from 'antd/es/app';
import ConfigProvider from 'antd/es/config-provider';
import theme from 'antd/es/theme';
import { RouterProvider } from 'react-router-dom';

import './App.css';
import { AccessibleTeamsProvider } from './contexts/AccessibleTeamsContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { DarkModeProvider, useDarkMode } from './contexts/DarkModeContext';
import { EditorSettingsProvider } from './contexts/EditorSettingsContext';
import { SessionUserProvider } from './contexts/SessionUserContext';
import { StyledComponentsThemeProvider } from './contexts/StyledComponentsThemeContext';
import { useBranding } from './hooks/useBranding';
import { queryClient } from './query-client';
import { router } from './routes/router';
import { GlobalStyles } from './styles/GlobalStyles';

function AppContent() {
  const currentBranding = useBranding();
  const [isDarkMode] = useDarkMode();

  return (
    <ConfigProvider
      theme={{
        token: currentBranding,
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <StyledComponentsThemeProvider>
        <AntdApp>
          <QueryClientProvider client={queryClient}>
            <SessionUserProvider>
              <AccessibleTeamsProvider>
                <RouterProvider router={router} />
              </AccessibleTeamsProvider>
            </SessionUserProvider>
          </QueryClientProvider>
          <GlobalStyles />
        </AntdApp>
      </StyledComponentsThemeProvider>
    </ConfigProvider>
  );
}

export default function App() {
  return (
    <BrandingProvider>
      <DarkModeProvider>
        <EditorSettingsProvider>
          <AppContent />
        </EditorSettingsProvider>
      </DarkModeProvider>
    </BrandingProvider>
  );
}
